import React from "react";
import { Icon } from "./icons";
import { Link } from "./Link";

export interface BreadcrumbInfo {
	url?: string,
	title: string,
}

export function Breadcrumb(props: {
}) {
	const context = useBreadcrumb();

	const items: BreadcrumbInfo[] = [];
	let o = context;
	while (o && o.info) {
		items.push(o.info);
		o = o.parent;
	}

	const els = [];
	for(let i=items.length-1;i>=0;i--) {
		const item = items[i];

		if (els.length > 0) els.push(<Icon key={i + "-arrow"} type="arrowRight" size="small" />); 
		if (item.url && (i > 0)) {
			els.push(
				<Link key={i} href={item.url} title={item.title} />
			);	
		} else {
			els.push(<span key={item.title}>{item.title}</span>);
		}
	}

	return (
		<div className="breadcrumb flex horiz gap-2">
			{els}
		</div>
	);
}

export interface BreadcrumbState {
	info: BreadcrumbInfo;
	
	parent: BreadcrumbState;
}

export function useBreadcrumb() {
	const context = React.useContext(BreadcrumbContext);
	return context;
}

export const BreadcrumbContext = React.createContext({} as BreadcrumbState);

export function BreadcrumbRegion(props: {
	url?: string,
	title: string,

	children: any,
}) {
	const parentContext = useBreadcrumb();
	
	const context = React.useMemo(() => {
		return {
			info: {
				url: props.url,
				title: props.title,
			},
			parent: parentContext,
		}
	}, [props.url, props.title, parentContext]);

	return (
		<BreadcrumbContext.Provider value={context}>
			{props.children}
		</BreadcrumbContext.Provider>
	)
}